import type { DisciplineStageLogsStore } from './interfaces'

export const getters = {
  isLoading: (state: DisciplineStageLogsStore): DisciplineStageLogsStore['loading'] => state.loading,
  getLogs: (state: DisciplineStageLogsStore): DisciplineStageLogsStore['logs'] => state.logs,
  hasLogs: (state: DisciplineStageLogsStore): boolean => state.logs.length > 0,
  getNextCursor: (state: DisciplineStageLogsStore): DisciplineStageLogsStore['nextCursor'] => state.nextCursor,
  hasMore: (state: DisciplineStageLogsStore): boolean => !!state.nextCursor,
}
